import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { useIconStore } from './state/IconStore';

// Pre-fetch icon overrides from the backend ONCE before any component mounts.
// This avoids all RadioWidgets re-rendering mid-display when the fetch completes.
useIconStore.getState().fetchIcons();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

